var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVuesaxOutlineBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_book",
    "data-name": "vuesax/outline/book",
    transform: "translate(-556 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "book"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.75,20.162a1.755,1.755,0,0,1-.85-.21,25.082,25.082,0,0,0-7.22-2.37l-.29-.04A2.817,2.817,0,0,1,0,14.822V2.742A2.712,2.712,0,0,1,2.97.012a19.317,19.317,0,0,1,7.4,2.45l.24.14a.389.389,0,0,0,.28.01l.16-.1A19.715,19.715,0,0,1,18.46.022h.12a2.651,2.651,0,0,1,2.04.71,2.707,2.707,0,0,1,.88,2.03v12.07a2.809,2.809,0,0,1-2.4,2.72l-.33.04a24.8,24.8,0,0,0-7.19,2.37A1.645,1.645,0,0,1,10.75,20.162ZM2.73,1.5a1.223,1.223,0,0,0-.84.32,1.237,1.237,0,0,0-.39.92v12.08a1.322,1.322,0,0,0,1.08,1.24l.3.04a26.562,26.562,0,0,1,7.7,2.52.449.449,0,0,0,.27.03,26.121,26.121,0,0,1,7.73-2.55l.34-.04A1.313,1.313,0,0,0,20,14.822V2.752a1.259,1.259,0,0,0-.39-.93,1.306,1.306,0,0,0-.96-.32h-.12a18.373,18.373,0,0,0-6.67,2.25l-.16.11a1.847,1.847,0,0,1-1.86.01l-.24-.14A18.413,18.413,0,0,0,2.85,1.5Z",
    transform: "translate(557.25 189.918)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M.75,16.5A.755.755,0,0,1,0,15.75V.75A.755.755,0,0,1,.75,0,.755.755,0,0,1,1.5.75v15A.749.749,0,0,1,.75,16.5Z",
    transform: "translate(567.25 192.74)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M3,1.5H.75A.755.755,0,0,1,0,.75.755.755,0,0,1,.75,0H3a.755.755,0,0,1,.75.75A.755.755,0,0,1,3,1.5Z",
    transform: "translate(560.75 195.74)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M3.75,1.5h-3A.755.755,0,0,1,0,.75.755.755,0,0,1,.75,0h3A.755.755,0,0,1,4.5.75.755.755,0,0,1,3.75,1.5Z",
    transform: "translate(560.75 198.74)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(556 188)",
    fill: "none",
    opacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineBook);
export default __webpack_public_path__ + "static/media/vuesax-outline-book.ecf422b39540dbe4621fee85ec3ca6d3.svg";
export { ForwardRef as ReactComponent };